module.exports = __webpack_public_path__ + "static/media/non1.8d776927.jpg";